export const environment = {
  production: false,
  cognito: {
    userPoolId: 'eu-central-1_PYzPlqxOu',
    clientId: '1g70cviqcauamuqdpo46ageuad',
    region: 'eu-central-1',
    domain: 'login.ocr-test.admin.fidectus.com',
    redirectUri: 'https://ocr-test.admin.fidectus.com/callback',
    logoutUri: 'https://ocr-test.admin.fidectus.com/login'
  },
  apiUrl: 'https://api.ocr-test.admin.fidectus.com',
  appsync: {
    httpEndpoint: 'https://gql.ocr-test.admin.fidectus.com/graphql',
    realtimeEndpoint: 'wss://gql.ocr-test.admin.fidectus.com/graphql/realtime'
  },
  // Engineer-facing dashboard created in lib/infrastructure/metrics.ts.
  cloudWatch: {
    region: 'eu-central-1',
    dashboardName: 'ocr-prime-monitoring-test'
  }
};
